module.exports = __webpack_public_path__ + "static/OneDotExt-Bold.39c3328b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt-Bold.eot
// module id = 747
// module chunks = 114276838955818